export const noop = () => {};
export const prevent = e => e.preventDefault();
